import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AdminContractorDetails from "./AdminContractorDetails";

export default function AdminContractorsDetailsModal({
  permissions,
  showContractorDetailsModal,
  toggleContractorDetailsModal,
  contractorId,
  handleClick_edit,
  deleteContractor,
  className,
}) {
  const closeBtn = (
    <button className="close" onClick={toggleContractorDetailsModal}>
      <FontAwesomeIcon icon="times" className="fa-fw text-white" />
    </button>
  );
  return (
    <Modal
      isOpen={showContractorDetailsModal}
      toggle={toggleContractorDetailsModal}
      className={className}
      size={"lg"}
      fade={false}
    >
      <ModalHeader
        toggle={toggleContractorDetailsModal}
        className="bg-info text-white"
        close={closeBtn}
      >
        <FontAwesomeIcon icon="info-circle" className="fa-fw mr-2" />
        Contractor Details
      </ModalHeader>
      <ModalBody>
        <AdminContractorDetails
          permissions={permissions}
          contractorId={contractorId}
          handleClick_edit={handleClick_edit}
          deleteContractor={deleteContractor}
        />
      </ModalBody>
      <ModalFooter className="bg-lightgray">
        <div className="form-row form-group float-right mb-0">
          <button
            type="button"
            name="closeContractorDetails"
            id="closeContractorDetails"
            className="btn btn-secondary"
            onClick={toggleContractorDetailsModal}
          >
            Close
          </button>
        </div>
      </ModalFooter>
    </Modal>
  );
}
